import { TListResponse } from 'src/common/types';
import { TTableSort, TTableSortCols } from 'src/components/table/thead/col';


export const ProviderListSourceSortCol = {
	ID: 'id',
	NAME: 'name',
	UPDATED_AT: 'updated_at',
	CREATED_AT: 'created_at',
};

export type TProviderListSourceSortCol = TTableSortCols<typeof ProviderListSourceSortCol>;

export type TProviderSourceQuery = {
	limit: number;
	offset: number;
	search?: string;
	sort?: TTableSort;
	sortCol?: TProviderListSourceSortCol;
};

export type TProviderListSourceQueryRequest = {
	limit?: number;
	offset?: number;
	search?: string;
	sort?: string;
	sort_col?: string;
};

export function adaptProviderListSourceQueryToRequest(data?: TProviderSourceQuery): TProviderListSourceQueryRequest {
	if (!data) {
		return {};
	}

	const {
		sortCol,
		...restFields
	} = data;

	return {
		sort_col: sortCol,
		...restFields
	};
}

export type TProviderSource = {
  id: number;
  name: string;
};

export type TProviderSourceResponse = TProviderSource;

export type TProviderSourceListResponse = TListResponse<TProviderSourceResponse>;

export type TProviderSourceList = TListResponse<TProviderSource>;

export function adaptProviderSourceFromListResponse(data: TProviderSourceListResponse): TProviderSourceList {
	const {
		items: itemsRaw = [],
		...restFields
	} = data;

	const items = itemsRaw.map(item => adaptProviderSourceFromResponse(item));

	return {
		items,
		...restFields
	};
}

export function adaptProviderSourceFromResponse(data: TProviderSourceResponse): TProviderSource {
	const {
		id,
		name,
	} = data;

	return {
		id,
		name,
	};
}
